<template>
	<div v-if="isApproved" class="c-admin-page">
		<PageHeader title="Admin">
			<template v-slot:title> Tax CSV export </template>
		</PageHeader>

		<Constrain size="sm">
			<AdminNav />
			<div class="c-admin-page__card">
				<p>
					Export deposited Stripe charges for non-Australian cards. Selected
					start and end months are both included, using UTC dates. CSV will be
					emailed to shash@swipekit.app.
				</p>

				<form @submit.prevent="submit">
					<div class="c-admin-page__months">
						<div class="form-group">
							<label for="tax-start-month">Start month</label>
							<input
								id="tax-start-month"
								v-model="startMonth"
								type="month"
								class="form-control"
								required
							/>
						</div>

						<div class="form-group">
							<label for="tax-end-month">End month</label>
							<input
								id="tax-end-month"
								v-model="endMonth"
								type="month"
								class="form-control"
								required
							/>
						</div>
					</div>

					<p v-if="errorMessage" class="c-admin-page__message error">
						{{ errorMessage }}
					</p>
					<p v-if="successMessage" class="c-admin-page__message success">
						{{ successMessage }}
					</p>

					<button
						type="submit"
						:class="['btn btn-primary', { disabled: processing }]"
						:disabled="processing"
					>
						<span v-if="processing" class="c-spinner"></span>
						<span v-if="processing">Processing Stripe charges...</span>
						<span v-else>Process and email CSV</span>
					</button>
				</form>
			</div>
		</Constrain>
	</div>

	<Page404 v-else></Page404>
</template>

<script>
import api from '@swipekit/lib/api';
import Constrain from '@swipekit/components/utils/constrain.vue';
import PageHeader from '@swipekit/components/utils/page-header.vue';
import Page404 from './page404.vue';
import AdminNav from './admin-nav.vue';

const approvedEmail = 'shash@swipekit.app';

function getCurrentMonth() {
	const now = new Date();
	const year = now.getFullYear();
	const month = String(now.getMonth() + 1).padStart(2, '0');

	return `${year}-${month}`;
}

export default {
	name: 'AdminPage',
	components: {
		AdminNav,
		Constrain,
		Page404,
		PageHeader,
	},
	data: function () {
		const currentMonth = getCurrentMonth();

		return {
			startMonth: currentMonth,
			endMonth: currentMonth,
			processing: false,
			errorMessage: '',
			successMessage: '',
		};
	},
	computed: {
		isApproved: function () {
			const user = this.$store.getters['users/user'];

			if (!user || !user.email) {
				return false;
			}

			return user.email.toLowerCase() === approvedEmail;
		},
	},
	methods: {
		async submit() {
			this.errorMessage = '';
			this.successMessage = '';

			if (!this.startMonth || !this.endMonth) {
				this.errorMessage = 'Choose both a start month and an end month.';
				return;
			}

			if (this.startMonth > this.endMonth) {
				this.errorMessage = 'End month must be the same as or later than start month.';
				return;
			}

			this.processing = true;

			try {
				await api.admin.sendTaxCsv({
					startMonth: this.startMonth,
					endMonth: this.endMonth,
				});
				this.successMessage = 'Tax CSV sent to shash@swipekit.app.';
			} catch (err) {
				this.errorMessage = 'Could not email tax CSV. Try again.';
			}

			this.processing = false;
		},
	},
};
</script>

<style lang="scss">
.c-admin-page {
	padding-bottom: var(--spacer);

	&__card {
		margin-top: var(--spacer-sm);
		padding: var(--spacer-sm);
		border: var(--color-bg-5) solid 1px;
		border-radius: 0.5rem;
		background-color: var(--color-bg-2);

		> p {
			margin-bottom: var(--spacer-sm);
			font-size: var(--font-size-sm);
		}
	}

	&__months {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: var(--margin-lg);
		margin-bottom: var(--margin-lg);

		.form-group,
		.form-control {
			width: 100%;
		}
	}

	&__message {
		margin-bottom: var(--margin-lg);
		font-size: var(--font-size-sm);

		&.error {
			color: var(--color-danger);
		}

		&.success {
			color: var(--color-success);
		}
	}

	.c-spinner {
		margin-right: var(--margin);
	}

	@media screen and (max-width: 600px) {
		&__months {
			grid-template-columns: 1fr;
		}
	}
}
</style>
